module.exports = __webpack_public_path__ + "img/-s-1@2x.320fc568.png";